import { FC } from 'react';
import Table from '@/components/Table/Table';
import Button from '@/components/Button/Button';
import CheckBox from '@/components/CheckBox/CheckBox';

import ExportTableButton from '@/components/ExportTableButton/ExportTableButton';
import { useTranslation } from 'react-i18next';
import { TableData } from '@/components/Table/types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
import { getHeaderColumnsGroup, tableColumns } from './tableColumns';
import ExchangesTableFilters from '../ExchangesTableFilters/ExchangesTableFilters';
import styles from './ExchangesTable.module.scss';
import { Exchange, TableFilters } from '../types';
import { tableFilters } from './tableFilters';

type ExchangesTableProps = {
  isLoading?: boolean;
  data?: Exchange[];
  filters: TableFilters;
  setFilters: (filters: TableFilters) => void;
  onSearch: () => void;
};

const ExchangesTable: FC<ExchangesTableProps> = ({
  isLoading,
  data,
  filters,
  setFilters,
  onSearch,
}) => {
  const { t } = useTranslation('exchangesHeaders');
  const submitButtonText = t('submitButton');
  const headerColumnsGroup = getHeaderColumnsGroup(t, data);
  const columnsToExport = [
    'playa',
    'armador',
    'contenedor',
    'tipoDeContenedor',
    'tamano',
    'fechaAbierto',
    'booking',
    'matricula',
    'precinto1',
    'precinto2',
    'precinto3',
    'precinto4',
    'motivo',
    'viajeImport',
    'origen',
    'fechaLlegada',
    'imoImport',
    'viajeExport',
    'destino',
    'fechaSalida',
    'exportador',
    'imoExport',
  ];

  const handleCheckboxChange = (incluirCargas: boolean) => {
    setFilters({ ...filters, incluirCargas });
  };

  const handleSearchClick = () => {
    onSearch();
  };

  return (
    <div className={styles.ExchangesTable}>
      <header className={styles.header}>
        <div className={styles.filtersContainer}>
          <ExchangesTableFilters filters={filters} setFilters={setFilters} />
        </div>

        <div className={styles.containerRigth}>
          <CheckBox
            className={styles.checkbox}
            onChange={handleCheckboxChange}
            label={t('checkBox')}
          />
          <Button
            type="submit"
            className={styles.submitButton}
            onClick={handleSearchClick}
          >
            <FontAwesomeIcon icon={faMagnifyingGlass} className={styles.icon} />
            {submitButtonText}
          </Button>
        </div>
        <div className={styles.containerExport}>
          <ExportTableButton
            data={
              data?.map((val) => {
                if (val.destino) {
                  return {
                    ...val,
                    destino: val.destino.split(' ').filter(Boolean).join('/'),
                  };
                }
                return val;
              }) as TableData
            }
            columnsToExport={columnsToExport}
            adjustTitles
          />
        </div>
      </header>

      <div>
        <Table
          columns={tableColumns}
          data={data}
          isLoading={isLoading}
          headerColumnGroup={headerColumnsGroup}
          className={styles.table}
          paginator
          rows={10}
          autoRowsToFillViewport
          filterDisplay="menu"
          filters={tableFilters}
        />
      </div>
    </div>
  );
};

export default ExchangesTable;
